/* tslint:disable */
/* eslint-disable */
/**
 * order-retrieval
 * Order Retrieval - retrieves order information given the ordernumber
 *
 * The version of the OpenAPI document: 2.2.1
 * Contact: dl.selling.slf_sapi.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DtoPrice } from './DtoPrice';
import {
    DtoPriceFromJSON,
    DtoPriceFromJSONTyped,
    DtoPriceToJSON,
} from './DtoPrice';
import type { DtoProvidedServicePriceDetails } from './DtoProvidedServicePriceDetails';
import {
    DtoProvidedServicePriceDetailsFromJSON,
    DtoProvidedServicePriceDetailsFromJSONTyped,
    DtoProvidedServicePriceDetailsToJSON,
} from './DtoProvidedServicePriceDetails';
import type { DtoTaxDetail } from './DtoTaxDetail';
import {
    DtoTaxDetailFromJSON,
    DtoTaxDetailFromJSONTyped,
    DtoTaxDetailToJSON,
} from './DtoTaxDetail';
import type { DtoTimeWindow } from './DtoTimeWindow';
import {
    DtoTimeWindowFromJSON,
    DtoTimeWindowFromJSONTyped,
    DtoTimeWindowToJSON,
} from './DtoTimeWindow';
import type { Embedded } from './Embedded';
import {
    EmbeddedFromJSON,
    EmbeddedFromJSONTyped,
    EmbeddedToJSON,
} from './Embedded';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';

/**
 * 
 * @export
 * @interface DtoProvidedService
 */
export interface DtoProvidedService {
    /**
     * 
     * @type {Embedded}
     * @memberof DtoProvidedService
     */
    _embedded?: Embedded;
    /**
     * 
     * @type {Links}
     * @memberof DtoProvidedService
     */
    _links?: Links;
    /**
     * 
     * @type {number}
     * @memberof DtoProvidedService
     */
    lineId?: number;
    /**
     * 
     * @type {DtoPrice}
     * @memberof DtoProvidedService
     */
    price?: DtoPrice;
    /**
     * 
     * @type {Array<number>}
     * @memberof DtoProvidedService
     */
    referencedItems?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    capacityUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof DtoProvidedService
     */
    capacityValue?: number;
    /**
     * 
     * @type {number}
     * @memberof DtoProvidedService
     */
    deliveryNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    priceCalculationType?: string;
    /**
     * 
     * @type {number}
     * @memberof DtoProvidedService
     */
    priceCalculationValue?: number;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    serviceItemNo?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    serviceItemType?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    serviceName?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    servicePaymentTo?: DtoProvidedServiceServicePaymentToEnum;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    serviceProductId?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    serviceProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    serviceProviderName?: string;
    /**
     * 
     * @type {number}
     * @memberof DtoProvidedService
     */
    taxableAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    statusText?: string;
    /**
     * 
     * @type {Array<DtoTaxDetail>}
     * @memberof DtoProvidedService
     */
    taxRates?: Array<DtoTaxDetail>;
    /**
     * 
     * @type {Array<DtoTimeWindow>}
     * @memberof DtoProvidedService
     */
    timeWindows?: Array<DtoTimeWindow>;
    /**
     * 
     * @type {string}
     * @memberof DtoProvidedService
     */
    taxationInfo?: string;
    /**
     * 
     * @type {DtoProvidedServicePriceDetails}
     * @memberof DtoProvidedService
     */
    providedServicePriceDetails?: DtoProvidedServicePriceDetails;
}


/**
 * @export
 */
export const DtoProvidedServiceServicePaymentToEnum = {
    SP: 'PAY_TO_SP',
    IKEA: 'PAY_TO_IKEA',
    unknown_default_open_api: '11184809'
} as const;
export type DtoProvidedServiceServicePaymentToEnum = typeof DtoProvidedServiceServicePaymentToEnum[keyof typeof DtoProvidedServiceServicePaymentToEnum];


/**
 * Check if a given object implements the DtoProvidedService interface.
 */
export function instanceOfDtoProvidedService(value: object): boolean {
    return true;
}

export function DtoProvidedServiceFromJSON(json: any): DtoProvidedService {
    return DtoProvidedServiceFromJSONTyped(json, false);
}

export function DtoProvidedServiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DtoProvidedService {
    if (json == null) {
        return json;
    }
    return {
        
        '_embedded': json['_embedded'] == null ? undefined : EmbeddedFromJSON(json['_embedded']),
        '_links': json['_links'] == null ? undefined : LinksFromJSON(json['_links']),
        'lineId': json['lineId'] == null ? undefined : json['lineId'],
        'price': json['price'] == null ? undefined : DtoPriceFromJSON(json['price']),
        'referencedItems': json['referencedItems'] == null ? undefined : json['referencedItems'],
        'capacityUnit': json['capacityUnit'] == null ? undefined : json['capacityUnit'],
        'capacityValue': json['capacityValue'] == null ? undefined : json['capacityValue'],
        'deliveryNumber': json['deliveryNumber'] == null ? undefined : json['deliveryNumber'],
        'priceCalculationType': json['priceCalculationType'] == null ? undefined : json['priceCalculationType'],
        'priceCalculationValue': json['priceCalculationValue'] == null ? undefined : json['priceCalculationValue'],
        'serviceItemNo': json['serviceItemNo'] == null ? undefined : json['serviceItemNo'],
        'serviceItemType': json['serviceItemType'] == null ? undefined : json['serviceItemType'],
        'serviceName': json['serviceName'] == null ? undefined : json['serviceName'],
        'servicePaymentTo': json['servicePaymentTo'] == null ? undefined : json['servicePaymentTo'],
        'serviceProductId': json['serviceProductId'] == null ? undefined : json['serviceProductId'],
        'serviceProviderId': json['serviceProviderId'] == null ? undefined : json['serviceProviderId'],
        'serviceProviderName': json['serviceProviderName'] == null ? undefined : json['serviceProviderName'],
        'taxableAmount': json['taxableAmount'] == null ? undefined : json['taxableAmount'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusText': json['statusText'] == null ? undefined : json['statusText'],
        'taxRates': json['taxRates'] == null ? undefined : ((json['taxRates'] as Array<any>).map(DtoTaxDetailFromJSON)),
        'timeWindows': json['timeWindows'] == null ? undefined : ((json['timeWindows'] as Array<any>).map(DtoTimeWindowFromJSON)),
        'taxationInfo': json['taxationInfo'] == null ? undefined : json['taxationInfo'],
        'providedServicePriceDetails': json['providedServicePriceDetails'] == null ? undefined : DtoProvidedServicePriceDetailsFromJSON(json['providedServicePriceDetails']),
    };
}

export function DtoProvidedServiceToJSON(value?: DtoProvidedService | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        '_embedded': EmbeddedToJSON(value['_embedded']),
        '_links': LinksToJSON(value['_links']),
        'lineId': value['lineId'],
        'price': DtoPriceToJSON(value['price']),
        'referencedItems': value['referencedItems'],
        'capacityUnit': value['capacityUnit'],
        'capacityValue': value['capacityValue'],
        'deliveryNumber': value['deliveryNumber'],
        'priceCalculationType': value['priceCalculationType'],
        'priceCalculationValue': value['priceCalculationValue'],
        'serviceItemNo': value['serviceItemNo'],
        'serviceItemType': value['serviceItemType'],
        'serviceName': value['serviceName'],
        'servicePaymentTo': value['servicePaymentTo'],
        'serviceProductId': value['serviceProductId'],
        'serviceProviderId': value['serviceProviderId'],
        'serviceProviderName': value['serviceProviderName'],
        'taxableAmount': value['taxableAmount'],
        'status': value['status'],
        'statusText': value['statusText'],
        'taxRates': value['taxRates'] == null ? undefined : ((value['taxRates'] as Array<any>).map(DtoTaxDetailToJSON)),
        'timeWindows': value['timeWindows'] == null ? undefined : ((value['timeWindows'] as Array<any>).map(DtoTimeWindowToJSON)),
        'taxationInfo': value['taxationInfo'],
        'providedServicePriceDetails': DtoProvidedServicePriceDetailsToJSON(value['providedServicePriceDetails']),
    };
}

